/* eslint-disable no-empty-pattern */

import { callAxios } from '@/lib/api/axios';
import { saveLocalData, removeLocalData } from '@/lib/base/localData';
import { NotifyError } from '@/plugins/notify';
import router, { isPublicLocation } from '@/router';
import { clientVersion } from '../../constants/env';

let thsrRole = clientVersion === 'thsr-main' || clientVersion === 'test';
// import lodash from 'lodash'

let apiPromise = {};

export const getters = {
  isAdmin(state){
    return state.details.roles === 'admin';
  },
  isProjectManager(state) {
    if (state.details.roles !== 'manager') return false;
    const mp = state.details.managed_projects;
    return Array.isArray(mp) && mp.length > 0;
  },
  managedProjects(state) {
    return state.details.managed_projects || [];
  },
  // 是否有「部分 admin」存取權限（admin 或 project manager）
  hasAdminAccess(state, getters) {
    return getters.isAdmin || getters.isProjectManager;
  },
  isAuthenticated(state) {
    return state.isLoggedIn;
  },
  details(state) {
    return state.details;
  },
};
const initialState = () => ({
  details: {},
  isLoggedIn: false,
});

export const state = {
  details: {},
  isLoggedIn: false,
};

export const actions = {
  loginUser({ dispatch }, user) {
    let thsrToken = null;
    return callAxios({
      category: 'user',
      apiName: 'login',
      method: 'post',
      data: user,
    })
      .then(res => {
        thsrToken = res.data.token;
        saveLocalData('jwt', `Bearer ${thsrToken}`);
        return dispatch('getUserData', true);
      })
      .then(userData=>{
        if(thsrRole && (userData.roles == 'admin' || userData.roles == 'thsr')){
          // rain 後端改為用 THSR token 換發自己的 token，不再收 email/password
          return callAxios({
            category: 'user',
            apiName: 'login',
            method: 'post',
            data: { thsrToken },
            useUrl: 'https://api-thsr-rain.geosupply.com.tw/',
          })
            .then(res => {
              saveLocalData('thsr-rain', `Bearer ${res.data.token}`);
            })
            .catch(error => {
              // rain 登入失敗不擋整體登入流程，THSR 主系統仍可正常使用
              // （401／已停用帳號的情況已由 axios.js 的全域攔截器處理登出與提示）
              const msg = error?.response?.data?.message;
              NotifyError(msg || '暴雨預警系統登入失敗，部分功能可能無法使用');
            });
        }
      })
      .catch(error => {
        //NotifyError(error);
        throw error;
      });
  },
  async logoutUser({ commit }) {
    try {
      await callAxios({
        category: 'user',
        apiName: 'logout',
        method: 'post',
      });
    } catch (_) {
      // token 可能已失效，忽略錯誤，仍繼續清除本地狀態
    }
    commit('resetState');
  },
  refreshToken() {
    return callAxios({
      category: 'user',
      apiName: 'refreshToken',
      method: 'post',
    }).then(res => {
      saveLocalData('jwt', `Bearer ${res.data.token}`);
    });
  },
  getUserData({ commit }, isUpdate) {
    const apiName = 'getUserData';
    if (apiPromise[apiName] && !isUpdate) return apiPromise[apiName];
    return callAxios({
      category: 'user',
      method: 'get',
      apiName: 'getUser',
    })
      .then(res => {
        commit('setUser', res.data);
        saveLocalData('user', res.data);
        return res.data;
      })
      .catch(error => {
        NotifyError(error);
      });
  },
};

export const mutations = {
  setUser(state, data) {
    state.details = data;
    state.isLoggedIn = true;
  },
  resetState(state) {
    removeLocalData('user');
    removeLocalData('jwt');
    removeLocalData('thsr-rain');
    removeLocalData('projectList');
    removeLocalData('selectedProject');
    const initial = initialState();
    Object.keys(initial).forEach(key => {
      state[key] = initial[key];
    });
    // 公開頁面不需登入，token 失效時只清除登入狀態，留在原頁面
    if (isPublicLocation()) return;
    router.push({
      path: '/login',
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
